import { useEffect } from "react";

const TawkMessenger = () => {
  useEffect(() => {
    var Tawk_API = window.Tawk_API || {};
    var Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = "https://embed.tawk.to/68ab53d29d850b192697323f/1j3ejusbr";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");

    const s0 = document.getElementsByTagName("script")[0];
    s0.parentNode.insertBefore(s1, s0);

    return () => {
      // Cleanup: remove script if component unmounts
      s1.remove();
    };
  }, []);

  return null; // Nothing needs to be rendered
};

export default TawkMessenger;
